import React, { useState, useEffect } from 'react'

import { Col, Message, Panel, Row } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanel from '../../ButtonPanel'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'
import ViewFormWidget from '../dynamicForm/ViewFormWidget'
import EditFormWidget from '../dynamicForm/EditFormWidget'
import HTMLWidget from '../../HTMLWidget'
import InputCheckboxForm from '../../../components/forms/input/InputCheckboxForm'
import { saveFormProjectResponsibler } from '../../../redux/actions/subProjectProposal'
import { setAlertMessage } from '../../../utils/messageUtil'
import { sessionGetItemStr } from '../../../utils/sessionHelpers'
import { SUB_PROJECT_ID } from '../../../constants/constants'
import { DEFAULT_ERR_MSG, SAVE_SUCCESS_MSG } from '../../../constants/msgText'
import { doneLoading, startLoading } from '../../../utils/loading'
import CustomAlertMessage from '../../CustomAlertMessage'

export default function ProjectResponsiblerWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit, setIsSameGrantee } = props

  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [notiMsg, setNotiMsg] = useState()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [sameGrantee, setSameGrantee] = useState(props.schema?.sameGrantee?.value)
  const [disabled, setDisabled] = useState(false)

  const mode = location.search.substring(1)
  const subProjectId = sessionGetItemStr(SUB_PROJECT_ID)

  useEffect(() => {
    setFormSchema(props.schema)
    setSameGrantee(props.schema?.sameGrantee?.value)
  }, [props.schema])

  const handleSave = async (request) => {
    setIsLoading(true)
    startLoading()
    try {
      let response = await saveFormProjectResponsibler(subProjectId, request)
      if (response) {
        setFormSchema(response)

        setIsSameGrantee(sameGrantee)

        setAlertMessage('success', SAVE_SUCCESS_MSG, setNotiMsg)
      } else {
        setAlertMessage('error', DEFAULT_ERR_MSG, setNotiMsg)
      }
    } catch (e) {
      console.log('error', e)
      setAlertMessage('error', e?.response?.data?.errors?.message || DEFAULT_ERR_MSG, setNotiMsg)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let values = []
    let subForm = []

    if (formSchema.sameGrantee) {
      let sameGranteeValue = sameGrantee?.includes('1') ? '1' : '0'

      values.push({
        //key: e.id,
        name: formSchema.sameGrantee.name,
        value: sameGranteeValue,
        //type: e.type,
      })
    }

    if (!sameGrantee?.includes('1')) {
      formSchema.objects?.forEach((e) => {
        if (e.type == 'HEADER_LABEL' || e.type == 'LABEL') {
          //ไม่ทำอะไร
        } else if (e.type == 'ADDRESS') {
          e.subSchemas?.forEach((se) => {
            if (se.sameAddress && data[se.sameAddress.name] != '0') {
              var sameValue = data[se.sameAddress.name]

              subForm.forEach((sev) => {
                if (
                  sev.typeId == e.id &&
                  (sev.values[0].key == sameValue ||
                    sev.values.find((e) => e.name == 'otherRefers' && e.value == sameValue))
                ) {
                  sev.values.push({
                    //key: se.typeId,
                    name: 'otherRefers',
                    value: se.typeId,
                    //type: seo.type,
                  })
                }
              })
            } else {
              let subValues = []

              se.objects?.forEach((seo) => {
                subValues.push({
                  key: se.typeId,
                  name: seo.name,
                  value: data[seo.name] || null,
                  type: seo.type,
                })
              })

              subForm.push({
                id: se.id,
                typeId: e.id,
                values: subValues,
              })
            }
          })
        } else {
          values.push({
            key: e.id,
            name: e.name,
            value: data[e.name] || null,
            type: e.type,
          })
        }
      })
    }

    let request = {
      id: formSchema.id,
      values: values,
      subForm: subForm,
    }

    console.log('request : ', JSON.stringify(request))

    handleSave(request)
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
      style={{ marginBottom: 20 }}
    >
      {isLoading && <OverlayLoader />}

      {/* <WarningMessage message={formSchema?.feedbackBySubject} /> */}

      {isEdit && showCommandButton ? (
        <div style={{ marginTop: -10 }}>
          {formSchema.description && (
            <Row style={{ marginBottom: 10 }}>
              <CustomAlertMessage contents={formSchema.description} />
            </Row>
          )}

          {formSchema.sameGrantee && (
            <Panel style={{ marginBottom: -20 }}>
              <Row>
                <Col>
                  <InputCheckboxForm
                    schema={formSchema.sameGrantee}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    onChange={(value) => {
                      setDisabled(value?.includes('1'))
                      setSameGrantee(value || [])
                    }}
                  />
                </Col>
              </Row>
            </Panel>
          )}

          {!sameGrantee?.includes('1') && (
            <EditFormWidget
              ignoreDesc
              schema={formSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
              setLoading={setIsLoading}
              disabled={disabled}
            />
          )}
        </div>
      ) : (
        <div style={{ marginTop: -10 }}>
          {formSchema.sameGrantee?.value != '1' ? (
            <ViewFormWidget schema={formSchema} />
          ) : (
            <ViewFormWidget objectDatas={[{ ...formSchema.sameGrantee, type: 'DOPDOWN' }]} />
          )}
        </div>
      )}

      {formSchema.note && (
        <Message
          showIcon
          type="info"
          style={{ marginTop: 20 }}
          description={<HTMLWidget data={formSchema.note} />}
        />
      )}

      {showCommandButton && !mode && (
        <div className="right">
          <hr />
          {notiMsg && (
            <Message
              closable
              showIcon
              type={notiMsg.type}
              description={notiMsg.msg}
              onClose={() => setNotiMsg('')}
              style={{ marginBottom: 10 }}
              className="left"
            />
          )}
          <ButtonPanel
            isDisabled={isLoading}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || formSchema.header}
            onSave={handleSubmit(onSubmit)}
            onCancel={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
            }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </div>
      )}
    </Panel>
  )
}
